import { render, staticRenderFns } from "./ProtocolBbk.vue?vue&type=template&id=1134faf2&scoped=true&"
import script from "./ProtocolBbk.vue?vue&type=script&lang=js&"
export * from "./ProtocolBbk.vue?vue&type=script&lang=js&"
import style0 from "./ProtocolBbk.vue?vue&type=style&index=0&id=1134faf2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1134faf2",
  null
  
)

export default component.exports